import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow",
  "use": "icon-arrow-usage",
  "viewBox": "0 0 8 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 13\" id=\"icon-arrow\">\n  <path d=\"M1773.99,1444.45l1.46-1.44,5.08,5.05h0l1.46,1.44-1.46,1.44h0l-5.08,5.05-1.46-1.44,5.09-5.05Z\" transform=\"translate(-1774 -1443)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol